import type { FaireProductEntity } from "../../entity_types/product";

export const p_8n6hhh3gyq: FaireProductEntity = {
  token: "p_8n6hhh3gyq",
  type: "product",
  name: "baking watercolor workbook",
  brandToken: "b_mmdanrh9jf",
  brandName: "emily lex studio",
  imageUrl:
    "https://cdn.faire.com/fastly/83a2e4815ed3205693b4e252e50b162c0196a6c83a8f3cf423f801a8a97d368b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/7ccba7a151b1a25d4ca6f4bb3c45f9307d24fefbaec17c9a92c02e23fe2c19ce.jpeg",
    "https://cdn.faire.com/fastly/69378923dbcd17480309853c04aa00f0234f137b100b39e6ed84e7a5901c9b3f.jpeg",
    "https://cdn.faire.com/fastly/b81d8de8c9997d6616a30394f17c9dade17002f20d7eb74e8f0d0d6536075d91.jpeg",
    "https://cdn.faire.com/fastly/9a53fdfea6bed649e5df5dbb026ab07fa55b319afb4e72da6002a28b020a77a8.jpeg",
    "https://cdn.faire.com/fastly/ef50e4e18e4d3f856e7b5c0ce33917f0027afd081579a84b609db4b5ec621fc9.jpeg",
    "https://cdn.faire.com/fastly/c8b7cfe8dbb846479a5b4d42fe580a52080e222a5e7addaff36d2764c069e01c.jpeg",
    "https://cdn.faire.com/fastly/36f59f10d5a38144e1efcc19610f34d957d748f1fa1e8de887fffa26097362e5.jpeg",
  ],
  priceDollars: 12,
  description:
    "Twelve baking illustrations — a cupcake, layer cake, mixing bowl, lattice pie, tray of cookies, rolling pin with cookie cutters, and more — each pre-outlined with step-by-step instructions. Paintings take about thirty minutes from start to finish, making it approachable for first-time painters and a favorite for gifting.\n\nA natural fit for kitchen and home boutiques. Strong as a hostess or housewarming gift.\n",
  tags: [],
  msrpDollars: 24,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-14T07:11:11.995Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
